<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 512 512" :width="width" :height="height" :fill="fill" style="enable-background:new 0 0 512 512;" xml:space="preserve">
    <polygon points="222.949,302.964 222.949,512 289.051,467.933 289.051,302.964"/>
    <rect x="2.612" width="506.776" height="49.576"/>
    <polygon points="19.137,82.627 206.424,269.913 305.576,269.913 492.863,82.627"/>
  </svg>
</template>

<script>
export default {
  name: 'IconFilter',
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
    fill: {
      type: String,
      default: 'var(--dark)',
    },
  },
};
</script>
